import Button from "common/Button/Button";
import InputField from "common/InputField/InputField";
import { useEffect, useState } from "react";
import {
  useFetchTestTokenMutation,
  useLazyGetParticipantInfoQuery,
} from "service/APIService";
import { useDispatch } from "react-redux";
import { setParticipantDetails, setToken } from "store/authSlice";
import { useNavigate } from "react-router";
import Spinner from "common/Spinner/Spinner";
import ErrorMessage from "common/ErrorMessage/ErrorMessage";
import MaterialIcon from "common/MaterialIcon/MaterialIcon";
import { Constants } from "utils/Constants";
import SelectDropdown from "common/SelectDropdown/SelectDropdown";

const TestPage = () => {
  const [dropdownType, setDropdownType] = useState("Participant ID");
  const [ssn, setSsn] = useState("");
  const [planId, setPlanId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showTestPage, setShowTestPage] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [testPageMutation] = useFetchTestTokenMutation();
  const [participantMutation] = useLazyGetParticipantInfoQuery();

  const submit = () => {
    if (ssn === "") {
      setError({
        errorMessage: "SSN/Participant ID is missing.",
      });
      return;
    }

    if (planId === "") {
      setError({
        errorMessage: "Plan ID is missing.",
      });
      return;
    }

    if (dropdownType === "SSN" && ssn?.length !== 9) {
      setError({
        errorMessage: "SSN must be 9 digits.",
      });
      return;
    }

    setLoading(true);
    setError(null);
    testPageMutation({
      planId: planId,
      ssn: dropdownType === "SSN" ? ssn : "",
      participantId: dropdownType !== "SSN" ? ssn : "",
    })
      .unwrap()
      .then((res) => {
        dispatch(setToken(res));
        participantMutation()
          .unwrap()
          .then((response) => {
            dispatch(setParticipantDetails(response));
            if (response?.guestPpt) {
              navigate("/learning-center");
            } else {
              navigate("/dashboard");
            }
          });
      })
      .catch((err) => {
        setError(err?.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setSsn("");
  }, [dropdownType]);

  useEffect(() => {
    sessionStorage.removeItem("persist:root");
    if (
      [
        Constants.PROD_UI_URL,
        Constants.PROD_UI_KC_URL,
        Constants.PROD_UI_STL_URL,
      ].indexOf(window.location.hostname) > -1
    ) {
      setShowTestPage(false);
    }
  }, []);

  if (showTestPage) {
    return (
      <section className="p-4 position-relative" style={{ height: "100vh" }}>
        {loading && <Spinner />}
        {error && <ErrorMessage error={error} wrapperClassName="mb-2" />}

        <SelectDropdown
          label="Type"
          dropdownData={["SSN", "Participant ID"]}
          wrapperClassName="col-md-2 mb-3"
          selectClassName="w-100 py-2"
          select={(e) => setDropdownType(e)}
          value={dropdownType}
          ariaLabel="Select Type"
        />

        <InputField
          type={dropdownType === "SSN" ? "number" : "text"}
          label={dropdownType}
          key={ssn}
          wrapperClassName="col-md-2 mb-3"
          value={ssn}
          id="SSN"
          ariaLabel="Participant SSN"
          blur={(e) => setSsn(e)}
        />
        <InputField
          type="text"
          label="Plan ID"
          id="Plan-ID"
          wrapperClassName="col-md-2 mb-3"
          value={planId}
          ariaLabel="Participant Plan ID"
          blur={(e) => setPlanId(e)}
        />
        <Button
          type="primary"
          text="Submit"
          wrapperClassName="col-md-1"
          click={submit}
          ariaLabel="Submit Button"
        />
        <MaterialIcon iconName="key" wrapperClassName="visually-hidden" />
      </section>
    );
  } else {
    return <div className="text-center h2 pt-3">UNAUTHORIZED</div>;
  }
};

export default TestPage;
